import { render, staticRenderFns } from "./UserAgreement.vue?vue&type=template&id=7660300b&scoped=true&"
var script = {}
import style0 from "./UserAgreement.vue?vue&type=style&index=0&id=7660300b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7660300b",
  null
  
)

export default component.exports